<script>
  export let anotherText = "Lorem ipsum";
</script>

<div class="Text">
  <p>{anotherText}</p>
</div>